import EmblaCarousel from '@/components/carousel';
import { Banner } from '@/types/banner';
import { Slider } from '@/types/slider';
import { PageType } from '@/utils/routing';

import { BannerContent } from './banner-content';

interface HeaderContentProps {
    pageType: PageType;
    pathname: string;
    sliders: Slider[];
    banner: Banner;
    aboutBanner: Banner;
}

export const HeaderContent = ({ pageType, pathname, sliders, banner, aboutBanner }: HeaderContentProps) => {
    // Extract path parts to determine specific page
    const pathParts = pathname.split('/').filter(Boolean);
    const mainPath = pathParts.length > 1 ? pathParts[1] : '';

    // Main page shows carousel
    if (pageType === 'main') {
        return <EmblaCarousel slides={sliders} />;
    }

    // Default page type with recipes or about path shows banner
    if (pageType === 'default') {
        if (mainPath === 'about') {
            return <BannerContent banner={aboutBanner} />;
        }

        return <BannerContent banner={banner} titleClassName='line-clamp-1' />;
    }

    return null;
};
